import { render } from "./Feedback.vue?vue&type=template&id=24de0ccb&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"

import "./Feedback.vue?vue&type=style&index=0&id=24de0ccb&lang=scss&scoped=true"
import "./Feedback.vue?vue&type=style&index=1&id=24de0ccb&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24de0ccb"]])

export default __exports__